import { Theme } from "@mui/material";
import { CustomTabsType } from "./types";

const getIconTypeStyles = (theme: Theme) => {
  return {
    minHeight: "fit-content",
    "& .MuiTabs-scroller": {
      height: "fit-content",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
    "& .MuiTab-root": {
      ...theme.typography.button,
      padding: { xs: "4px", md: "6px" },
      minWidth: "fit-content",
      minHeight: "fit-content",
      borderRadius: "8px",
      "& svg": {
        fill: '#D9D9D9',
        width: { xs: "24px", md: "32px" },
        height: { xs: "24px", md: "32px" },
      },
      "&.Mui-selected": {
        backgroundColor: theme.palette.primary.main,
        "& svg": {
          fill: theme.palette.common.white,
        },
      },
      ":not(:last-child)": {
        marginRight: { xs: "12px", md: "20px" },
      },
    },
  };
};

const getTextWithIconTypeStyles = (theme: Theme) => {
  return {
    minHeight: "fit-content",
    "& .MuiTabs-scroller": {
      height: "fit-content",
      fontSize: "1.125rem",
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    "& .MuiTab-root": {
      textTransform: "none",
      minWidth: "fit-content",
      minHeight: "fit-content",
      padding: { xs: "5px 0px 13px", md: "5px 0px 20px" },
      "& svg": {
        width: { xs: "24px", md: "32px" },
        height: { xs: "24px", md: "32px" },
        marginRight: "8px",
        fill: "#707580"
      },
      ":not(:last-child)": {
        marginRight: { xs: "24px", md: "48px" },
      },
      "&.Mui-selected": {
        color: theme.palette.text.primary,
        "& svg": {
          fill: theme.palette.primary.main,
        },
      },
    },
  };
};

const getTextTypeStyles = (theme: Theme) => {
  return {
    minHeight: "fit-content",
    "& .MuiTabs-scroller": {
      boxSizing: "border-box",
      height: "fit-content",
      borderBottom: { xs: `1px solid ${theme.palette.grey[200]}`, md: "none" },
    },
    "& .MuiTab-root": {
      textTransform: "none",
      fontSize: { xs: "1rem", md: "1.5rem" },
      minWidth: "fit-content",
      minHeight: "fit-content",
      padding: { xs: "5px 0px 12px", md: "5px 0px 16px" },
      ":not(:last-child)": {
        marginRight: { xs: "24px", md: "32px" },
      },
      "&.Mui-selected": {
        color: theme.palette.text.primary,
      },
    },
  };
};

export const getStyles = (theme: Theme, type: CustomTabsType) => {
  switch (type) {
    case "icon":
      return getIconTypeStyles(theme);
    case "text":
      return getTextTypeStyles(theme);
    case "textWithIcon":
      return getTextWithIconTypeStyles(theme);
  }
};
